import { render, staticRenderFns } from "./special-span.vue?vue&type=template&id=4b702520&scoped=true&"
import script from "./special-span.vue?vue&type=script&lang=ts&"
export * from "./special-span.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b702520",
  null
  
)

export default component.exports